import {SvgIconProps} from "@mui/material/SvgIcon";
import {ElementType, isValidElement, ReactElement} from "react";
import {Box, styled, SxProps} from "@mui/material";
import {scale} from "../../utils";
import Text from "../text";
import theme, {FONTS} from "../../constants/theme";

type IconProp =
  | { IconComponent: ElementType<SvgIconProps>; color?: SvgIconProps['color']; }
  | { IconComponent: ReactElement; color?: never };

interface CommonProps {
  firstRowText: string;
  secondRowText?: string;
  bgColor?: string;
  colorStyle: 'primary' | 'secondary';
  sx?: SxProps;
  textSx?: SxProps;
  iconSx?: SxProps;
  onClick?: () => void;
}

type Props = IconProp & CommonProps;

const InfoRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: scale(20),
})

const IconContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>(({ bgColor, theme }) => ({
  minWidth: scale(50),
  width: scale(50),
  height: scale(50),
  backgroundColor: bgColor ?? theme.palette.primary.main,
  borderRadius: scale(12),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const TextContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
})

const DateRowInfo = ({IconComponent, bgColor, color, sx, textSx, firstRowText, secondRowText, colorStyle, iconSx, onClick}: Props) => {
  return (
    <InfoRow sx={sx} onClick={onClick}>
      <IconContainer bgColor={bgColor} sx={iconSx}>
        {isValidElement(IconComponent) ? (
          IconComponent
        ) : (
          <IconComponent
            sx={{
              zIndex: 2,
              fontSize: scale(36)
            }}
            color={color ?? "white"}
          />
        )}
      </IconContainer>
      <TextContainer>
        <Text
          text={firstRowText}
          fontFamily={FONTS.MONTSERRAT}
          color={colorStyle === 'secondary' ? theme.palette.text.primary : theme.palette.ceramic.contrastText}
          fontSize={scale(20)}
          fontWeight={600}
          lineHeight={scale(24)}
          letterSpacing={scale(0.4)}
          sx={{ textTransform: 'uppercase', textAlign: 'left', width: scale(240), ...textSx}}
        />
        {secondRowText && (
          <Text
            text={secondRowText}
            fontFamily={FONTS.MONTSERRAT}
            color={colorStyle === 'secondary' ? theme.palette.text.primary : theme.palette.ceramic.contrastText}
            fontSize={scale(20)}
            fontWeight={600}
            lineHeight={scale(24)}
            letterSpacing={scale(0.4)}
            sx={{textTransform: 'uppercase', textAlign: 'left', width: scale(240), ...textSx}}
          />
        )}
      </TextContainer>
    </InfoRow>
  )
}

export default DateRowInfo
